export const userInitialState = {};
export default function userReducer(state = userInitialState) {
    return {
        ...state,
    };
}
